import React from 'react';
import { Link } from 'react-router-dom';
import RoutesApp from '../../routes';

//Estilos
import './RecoverUserName.css';
import './RecoverUserNameMediaQueries.css';

function RecoverUserName({ states, functions }) {
    const {
        register,
        handleSubmit,
        watch,
        setError,
        formState: { errors },
        onSubmit,
    } = functions;

    const { emailSent } = states;

    const RequestPassword = (
        <div className="form-background" onSubmit={handleSubmit(onSubmit)}>
            <form className="form-recover_userName">
                <h3>
                    {!emailSent
                        ? 'Ingrese los siguientes datos para poder enviar su nombre de usuario a su correo'
                        : 'Correo enviado exitosamente. Revisa tu casilla para continuar.'}
                </h3>
                {!emailSent && (
                    <>
                        <label className="label-recover_userName">
                            <span>Apellido: </span>
                            <input
                                className="recover_userName-input"
                                type="text"
                                {...register('apellido', {
                                    required: 'Debe ingresar su apellido',
                                })}
                                onKeyPress={(e) => {
                                    if (e.target.value.length > 30) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            {errors.apellido && (
                                <small className="form__error">
                                    {errors.apellido?.message}
                                </small>
                            )}
                        </label>
                        <label className="label-recover_userName">
                            <span>Correo: </span>
                            <input
                                className="recover_userName-input"
                                type="email"
                                {...register('correo', {
                                    required: 'Debe ingresar un correo',
                                })}
                                onKeyPress={(e) => {
                                    if (e.target.value.length > 50) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            {errors.correo && (
                                <small className="form__error">
                                    {errors.correo?.message}
                                </small>
                            )}
                        </label>
                        <div className="recover_userName-footer">
                            <button className="btn btn-primary" type="submit">
                                Enviar
                            </button>
                            <Link to={RoutesApp.Login}>
                                <button className="btn btn-secondary">
                                    Cancelar
                                </button>
                            </Link>
                        </div>
                    </>
                )}
            </form>
        </div>
    );

    return RequestPassword;
}

export default RecoverUserName;
